import Link from 'next/link';
import Head from 'next/head';
import { Box, Stack, Typography } from '@mui/material';
import AuthLogin from './auth/AuthLogin';
import AuthPageShell from '../src/components/AuthForms/AuthPageShell';
import { useTranslation } from 'react-i18next';
import useLoginStore from '../stores/loginStore';
import { useAuth } from '../src/hooks/useAuth';
import Spinner from '../src/utils/Spinner/Spinner';
import { useRouter } from 'next/router';

const Login2 = () => {
  const { t } = useTranslation();
  const { isLoading: loginLoading } = useLoginStore();
  const { isAuthenticated, isLoading: authLoading, status } = useAuth();
  const router = useRouter();
  if (loginLoading || authLoading || status === 'INITIALIZING') {
    let message = "Iniciando sesión...";
    
    if (status === 'INITIALIZING') {
      message = "Verificando cuenta...";
    } else if (isAuthenticated) {
      message = "Preparando tu espacio de trabajo...";
    }

    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
        <Spinner text={message}/>
      </Box>
    );
  }

  if (isAuthenticated) {
    return null;
  }

  return (
    <>
      <Head>
        <title>Iniciar Sesión | agentiza.ai</title>
      </Head>
      <AuthPageShell onLogoClick={() => router.push('/')}>
        <AuthLogin
          subtitle={
            <Stack direction="row" spacing={1} justifyContent="center" mt={3}>
              <Typography color="textSecondary" variant="h6" fontWeight="500">
                {t('dont_have_account')}
              </Typography>
              <Typography
                component={Link}
                href="https://agentiza.ai/#section-B_wgXDnH"
                fontWeight="500"
                sx={{
                  textDecoration: 'none',
                  color: 'primary.main',
                }}
              >
                {t('create_account_here')}
              </Typography>
            </Stack>
          }
        />
      </AuthPageShell>
    </>
  );
};

Login2.layout = "Blank";
export default Login2;
